import { isEqual } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
  createPersonName,
  updatePersonName,
} from '../store/actions/person/personActions';
import { selectApplication } from '../store/selectors/applicationSelectors';
import {
  BASIC_ACCOUNT_UPGRADE_TYPES,
  suffixOptionsEnumerated,
} from '../util/constants';
import useApplicationUid from './useApplicationUid';

const usePersonNameDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();
  const Application = useSelector(selectApplication);

  const personNameDispatch = ({
    data,
    personUid,
    isPrimary,
    onSuccess,
    onError,
    defaultValues,
  }) => {
    const { AccountUpgradeType } = Application;
    const isUpgrade =
      AccountUpgradeType === BASIC_ACCOUNT_UPGRADE_TYPES.IN_PROCESS;
    const shouldSkip = isEqual(data, defaultValues);

    if (shouldSkip && !isUpgrade) {
      onSuccess();
      return;
    }

    const { FirstName, LastName, MiddleName, Suffix } = data;

    const SuffixType =
      Suffix?.value && Suffix?.value !== 'None'
        ? suffixOptionsEnumerated[Suffix?.value]
        : null;

    const requestData = {
      ApplicationUid,
      data: {
        FirstName,
        LastName,
        MiddleName,
        SuffixType,
      },
      PersonUid: personUid,
      isPrimary,
      onSuccess,
      onError,
    };

    if (defaultValues.FirstName && !isUpgrade) {
      dispatch(
        updatePersonName({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createPersonName({
        ...requestData,
      }),
    );
  };

  return { personNameDispatch };
};

export default usePersonNameDispatch;
